import { AuthenticatedLayout } from "../../../layouts/AuthenticatedLayout/AuthenticatedLayout";
import { FC } from "react";
import T4ASlipImportXmlLayout from "../../../components/T4ASlip/T4ASlipImportXMLLayout/T4ASlipImportXmlLayout";

export interface IT4ASlipImportXmlPage {}

export const T4ASlipImportXmlPage: FC<IT4ASlipImportXmlPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Import XML T4A Slip"
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Compliance", navigateTo: "/taxslip/t4a/list" },
        { text: "T4A", navigateTo: "/taxslip/t4a/list" },
        { text: "Import XML T4A Slips", navigateTo: "/taxslip/t4a/import-xml" },
      ]}
      mainContents={<T4ASlipImportXmlLayout />}
    />
  );
};
